import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/constants/all';
import * as Actions from '../../store/actions/general';
import * as Types from '../../store/types';
import { Formik, FormikActions, FormikProps, ErrorMessage } from 'formik';
import PwFormValidation from './validations/pw-form-val';
import { routes as Routes } from '../../store/constants/routes';
import * as GT from '../../tools/general-tools';
import { Log } from 'ng2-logger';
import Translator from '../../services/translate-factory';
import * as Constants from '../../store/constants/all';

const L = Log.create('PasswordForm');
const T = Translator.create();

class PasswordForm extends React.Component<Types.ILoginPageProps, Types.IForgotView> {
  state: Types.IForgotView = {
    password: '',
    password_confirm: '',
    token: '',
    account_id: '',
    email: '',
    usernameOrEmail: '',
  };

  langChanged = () => {
    setTimeout(() => {
      try {
        this.forceUpdate();
      } catch (e) {
        L.error(e as string);
      }
    }, 1000);
  };

  onSubmit = (model: Types.IForgotView, LoginActions: FormikActions<Types.IForgotView>) => {
    if (this.props.match && this.props.match.params) {
      model.token = this.props.match.params.token;
    }
    let newModel = {
      code: this.props.code,
      newPassword: model.password,
      newPasswordConfirm: model.password_confirm,
    };
    this.props.dispatch(Actions.ApiRequest(actions.login.LOGIN_RESET_PASSWORD, newModel, 'login-form-spin'));
    LoginActions.setSubmitting(false);
  };

  goLogin = () => {
    this.props.dispatch(Actions.Navigation(GT.Route(Routes.LOGIN)));
  };

  getGeneralSettings() {
    const resultCallback = (result: Types.IApiErrorResponse, status: number) => {
      if (status == 200) {
        let generalSettings: any = result;
        let language_default = generalSettings && generalSettings.language_default;
        if (language_default && language_default.length) {
          T.changeLanguage(language_default, true);
        }
      }
    };
    this.props.dispatch(Actions.ApiRequest(Constants.setting.GET_GENERAL_SETTINGS, '', 'general-settings-spin', resultCallback));
  }

  componentDidMount() {
    T.removeListener(Constants.gen.CORE_CHANGE_LANGUAGE, this.langChanged);
    T.addListener(Constants.gen.CORE_CHANGE_LANGUAGE, this.langChanged);

    this.getGeneralSettings();

    let language_default = this.props.general_settings && this.props.general_settings.language_default;
    if (language_default && language_default.length) {
      T.changeLanguage(language_default, true);
    }
  }

  componentWillUnmount() {
    T.removeListener(Constants.gen.CORE_CHANGE_LANGUAGE, this.langChanged);
  }

  render() {
    return (
      <React.Fragment>
        <h1>{T.t('gen_title_one_step_left')}</h1>
        <p>{T.t('gen_password_change_body')}</p>
        <Formik initialValues={this.state} onSubmit={this.onSubmit} validationSchema={PwFormValidation(T)}>
          {(props: FormikProps<Types.IForgotView>) => {
            return (
              <form onSubmit={props.handleSubmit}>
                <div className="form-group">
                  <div className="form-input">
                    <input
                      id="password"
                      type="password"
                      value={props.values.password}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                    />
                    <span className="highlight"></span>
                    <span className="bar"></span>
                    <label>{T.t('gen_password_new')}</label>
                  </div>
                  {props.errors.password && <div className="error">{props.errors.password}</div>}
                </div>
                <div className="form-group">
                  <div className="form-input">
                    <input
                      id="password_confirm"
                      type="password"
                      value={props.values.password_confirm}
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                    />
                    <span className="highlight"></span>
                    <span className="bar"></span>
                    <label>{T.t('gen_password_new_confirm')}</label>
                  </div>
                  {props.errors.password_confirm && <div className="error">{props.errors.password_confirm}</div>}
                </div>

                <div className="row align-items-center">
                  <div className="col">
                    <a href="javascript:;" onClick={this.goLogin}>
                      <i className="material-icons mr-3">keyboard_backspace</i>
                      {T.t('gen_previous')}
                    </a>
                  </div>
                  <div className="col text-right">
                    <button className="primary" type="submit" disabled={props.isSubmitting}>
                      {T.t('gen_password_reset')}
                      <i className="material-icons">arrow_forward</i>
                    </button>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (store: Types.IPersistedState, ownProps: Types.ILoginPageProps): Types.ILoginPageProps => {
  if (!store || !store.state) {
    return ownProps;
  }

  const newProps: any = Object.assign({}, ownProps, {
    account: store.state.account,
    definitions: store.state.definitions,
  });

  return newProps;
};

const dispatchProps = (dispatch: any) => ({ dispatch });

const container = connect(mapStateToProps, dispatchProps)(PasswordForm);

export default container;
